import { useState } from 'react'
import styled from 'styled-components'
import { audioItems } from '../data/audio'

function AudioList() {
  const [openId, setOpenId] = useState(null)

  const toggleItem = (id) => {
    setOpenId(openId === id ? null : id)
  }

  return (
    <Wrapper>
      {audioItems.map(item => {
        const isOpen = openId === item.id

        return (
          <Item key={item.id}>
            <Title onClick={() => toggleItem(item.id)}>
              {item.title}
              <Indicator>{isOpen ? '◐' : '◯'}</Indicator>
            </Title>

            <Content $isOpen={isOpen}>
              <Description>{item.description}</Description>

              <Audio controls>
                <source src={item.file} type="audio/mpeg" />
              </Audio>
            </Content>
          </Item>
        )
      })}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  max-width: 640px;
  margin: 0 auto;
  padding: 2rem;
`

const Item = styled.div`
  border-bottom: 1px solid rgba(0,0,0,0.1);
  padding: 1.2rem 0;
`

const Title = styled.h3`
  display: flex;
  justify-content: space-between;
  align-items: center;

  cursor: pointer;
  font-weight: 400;
  letter-spacing: 0.02em;

  transition: opacity 0.4s ease;

  &:hover {
    opacity: 0.6;
  }
`

const Indicator = styled.span`
  font-size: 0.9rem;
  opacity: 0.5;
`

const Content = styled.div`
  overflow: hidden;

  max-height: ${({ $isOpen }) => ($isOpen ? '300px' : '0')};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};

  transition: all 0.6s ease;

  margin-top: ${({ $isOpen }) => ($isOpen ? '0.8rem' : '0')};
`

const Description = styled.p`
  font-size: 0.95rem;
  line-height: 1.5;
  opacity: 0.7;
  margin-bottom: 0.8rem;
`

const Audio = styled.audio`
  width: 100%;
  opacity: 0.85;
`


export default AudioList